module.exports = __webpack_public_path__ + "media/images/story_symbolic-5f3886b6b29eba7fc75289c5a175eb61.jpg";